import AppSettings from "../AppSettings";

export const prefixedWithSlash = (url: string | number | undefined) =>
  url?.toString().startsWith("/") ? url.toString() : `/${url}`;

export const withoutSlashSuffix = (url: string) =>
  url.endsWith("/") ? url.substring(0, url.length - 1) : url;

export const combinedUrls = (baseUrl: string, relativeUrl: string | undefined) =>
  `${withoutSlashSuffix(baseUrl)}${prefixedWithSlash(relativeUrl)}`;

export const asAbsoluteApiUrl = (relativeUrl: string) =>
  combinedUrls(`${AppSettings.apiUrl}`, relativeUrl);
